import React from "react";
import { Col, Row } from "reactstrap";
import { T } from "../traks";
import { BinaryToggle } from "./BinaryToggle";

export const TeamModuleSection = ({ simple_checkbox_change, state }) => {
    return (
        <React.Fragment>
            <span className="txt-15px"><T>Activate the team module and let participants compete both individually and as part of a team. Perfect for schools, workplaces, and groups looking to strengthen community spirit and take competition to the next level.</T></span>

            <Row className="justify-content-center">
                <Col md="12" className="new_game_premium px-md-4 pt-4 pb-4">
                    <div className="text-left">
                        <BinaryToggle 
                            name="use_group_games"
                            checked={state.use_group_games}
                            onChange={simple_checkbox_change}
                            labels={[<T>Activate</T>, <T>Deactivate</T>]}
                        />
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    )
}


// WEBPACK FOOTER //
// ./src/c/TeamModuleSection.js